<template>
  <div class="address">
    <div class="top">
      <h3>地址管理</h3>
      <span class="add" @click="handleClick('add')">新增</span>
    </div>
    <div class="content">
      <ul>
        <li v-for="(item, index) in address">
          <div class="left">
            <p class="msg">
              <span class="name">{{item.name}}</span>
              <span class="tel">{{item.mobile}}</span>
            </p>
            <p class="site">地址：{{item.address}}</p>
            <p class="site">详细地址：{{item.addressInfo}}</p>
          </div>
          <div class="right">
            <span @click="handleClick('edit',index)">编辑</span>
            <span class="del" @click="del(item.id)">删除</span>
          </div>
        </li>
      </ul>
    </div>
    <edit-address v-if="isShow" @getAddress="getAddress" @handleClick="handleClick" :data="title" />
  </div>
</template>

<script>
import EditAddress from '../../../components/Person/EditAddress'
import {reqDelAddress} from '../../../api'
import {mapState} from 'vuex'
export default {
  data () {
    return{
      isShow: false,
      title: {}
    }
  },
  created() {
    this.getAddress()
  },
  methods: {
    // 获取地址信息
    getAddress() {
      this.$store.dispatch('getAddress')
    },
    // 显示新增和编辑
    handleClick (type, index) {
      this.isShow = !this.isShow
      if(type === 'add'){
        this.title = {title: '新增地址',type, addressInfo:{name:'', mobile:'', detaileAddress:'', address:''}}
      }else if (type === 'edit'){
        let address = (this.address)[index];
        address.detaileAddress = (this.address)[index].addressInfo;
        address.address = (this.address)[index].address;
        this.title = {title: '编辑地址', type, addressInfo:JSON.parse(JSON.stringify(address))}
        //this.title = {title: '编辑地址', type, addressInfo:{name:(this.address)[index].name, mobile:(this.address)[index].mobile, detaileAddress:(this.address)[index].addressInfo, address:(this.address)[index].address}}
      }
    },
    // 删除
    del (id) {
      reqDelAddress(id).then(res => {
        console.log(res)
        if(res.code === 200){
          this.$message({
            message: '删除成功',
            type: 'error'
          })
          this.$store.dispatch('getAddress')
        }
      })
    }
  },
  computed: {
    ...mapState(['address'])
  },
  components: {
    EditAddress
  }
}
</script>

<style scoped lang="less" type="text/less">
.address{
  .top{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top:60px;
    h3{
      font-size: 24px;
    }
    .add{
      display: block;
      width: 80px;
      height: 40px;
      border-radius: 20px;
      background: #2FA1DE;
      color:#fff;
      font-size: 16px;
      line-height: 40px;
      text-align: center;
      cursor: pointer;
    }
  }
  .content{
    margin-top:53px;
    ul{
      li{
        display: flex;
        justify-content: space-between;
        margin-top:30px;
        padding-bottom: 30px;
        border-bottom: 1px solid #e1e1e1;
        align-items: center;
        &:first-of-type{
          margin-top:0;
        }
        .left{
          .msg{
            .name{
              margin-right: 27px;
              font-size: 16px;
              font-weight: bold;
            }
          }
          .site{
            margin-top:19px;
          }
        }
        .right{
          span{
            display: inline-block;
            width: 100px;
            height: 40px;
            border-radius: 40px;
            border:1px solid #999;
            text-align: center;
            line-height: 40px;
            font-size: 16px;
            cursor: pointer;
            &.del{
              background: #f56c6c;
              color:#fff;
              border-color:#f56c6c;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Person/Children/Address.vue